export default __webpack_public_path__ + "hero-hits-boss-432a442e2cbb2a8b2535ce2c0ecaa193.mp3";